import { RowAlertAdministratorVehicleDto } from "@/dtos";
import { AlertAdministratorVehicle } from "@/entities";

export const formatRowAlertAdministratorVehicleDto = (alertAdministratorVehicles: AlertAdministratorVehicle[]) => {
    return alertAdministratorVehicles.map(x => {
        const row: RowAlertAdministratorVehicleDto = {
            ...x,
            administrator: x.details?.administrator,
            application: x.details?.application,
            alert_label: x.alert.name,
            vehicle_label: x.vehicle.name,
            company_label: x.company.name,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}